import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

import Help from '../generics/help';

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class DiscardsPerTurn extends Component {
    constructor(props) {
        super(props);

		this.handleChange = this.handleChange.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.generateExcel = this.generateExcel.bind(this);
		this.generatePDF = this.generatePDF.bind(this);
		this.searching = this.searching.bind(this);

        this.state = {		
			filename: "Listado de Descartes por Turno",

			start_date: '',
			start_folio: '',
			end_folio: '',
			work_sessions: [],
			work_sessions_id: 'all',
			option:"",

			columns: [
				{title: 'No. Bolsa', rowSpan: 2, width: '100px'},
				{title: 'No. Folio', rowSpan: 2, width: '100px'},
				{title: 'SANGRE TOTAL Y SUS COMPONENTES', colSpan: 5, cols: [], width: '200px'},
				{title: 'Fecha', rowSpan: 2, width:'100px'},
				{title: 'Causa', rowSpan: 2, width:'100px'},
				{title: 'Firma', rowSpan: 2, width:'100px'}
			],
			listado: []
		}
    }

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'work_sessions/actives?health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
		   	headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			} else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					work_sessions: response
				});
			}
	   });

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
			});
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	    

	    return isFormValid;
	}

	generateExcel(e){
		e.preventDefault();

		this.props.waiting.handleShow('Generando Excel...');

		var obj = {
			work_sessions_id: this.state.work_sessions_id,
			start_date: this.state.start_date,
			start_folio: this.state.start_folio,
			end_folio: this.state.end_folio,
			option: this.state.option,
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		};

		fetch(Config.default.apiGateway.URL+'reports_imss/generate_excel?report_name=discards_per_turn',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			this.props.waiting.handleClose();

			if(response !== undefined){
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})
	}

	generatePDF(e) {
		e.preventDefault();

		var obj = {
			work_sessions_id: this.state.work_sessions_id,
			start_date: this.state.start_date,
			start_folio: this.state.start_folio,
			end_folio: this.state.end_folio,
			option: this.state.option,
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		};

		this.props.waiting.handleShow('Generando PDF...');
		fetch(Config.default.apiGateway.URL+'reports_imss/generate_pdf?report_name=discards_per_turn',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var fileURL = URL.createObjectURL(response);
				window.open(fileURL);
			}
		})
	}

	searching(){
		if(this.isValidForm()){
			this.props.waiting.handleShow('Buscando...');

			var obj = {
				work_sessions_id: this.state.work_sessions_id,
				start_date: this.state.start_date,
				start_folio: this.state.start_folio,
				end_folio: this.state.end_folio,
				option:this.state.option,
				health_facilities_id: sessionStorage.getItem('health_facilities_id')
			};

			fetch(Config.default.apiGateway.URL+'reports_imss/discards_per_turn',{
				method: 'POST',
				body:JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					let columns = [
						{title: 'No. Bolsa', rowSpan: 2, width: '100px'},
						{title: 'No. Folio', rowSpan: 2, width: '100px'},
						{title: 'SANGRE TOTAL Y SUS COMPONENTES', colSpan: 0, cols: [], width: '200px'},
						{title: 'Fecha', rowSpan: 2, width:'100px'},
						{title: 'Causa', rowSpan: 2, width:'180px'},
						{title: 'Firma', rowSpan: 2, width:'130px'}
					];

					columns[2].colSpan = response.components.length;

					let totals = [
						'TOTAL',
						''
					];

					response.components.map(c => {
						columns[2].cols.push({title: c.code_name, width:'40px'});
						totals.push(0);
					});

					totals.push('');
					totals.push('');
					totals.push('');

					let listado = [];
					
					response.results.map(r => {
						let obj = [
							r.unit_number,
							r.discard_folio
						];

						response.components.map((c, i) => {
							let unit_comp = r.components.find(u => u.component_type === c.key);

							if (unit_comp !== undefined && unit_comp !== null) {
								obj.push(unit_comp.total);
								totals[i + 2] = parseInt(totals[i + 2]) + unit_comp.total;
							} else {
								obj.push('');
							}
						});

						obj.push(moment(r.date).format('DD/MM/YYYY') + ' ' + moment(r.hour, 'H:mm').format('HH:mm'));
						obj.push(r.discard_reasons);
						obj.push(r.user);

						listado.push(obj);
					});

					listado.push(totals);

					this.setState({
						listado: listado,
						columns: columns
					});

					this.props.waiting.handleClose();
				}
			});
		}
		else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

    render() {
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					IMSS ->
					{this.state.filename}
					</h5>
				</div>

				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_movimientos_st_fracciones"}  />
		        
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Fecha</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="form-group">
									<span className="span-min">Folio Desde</span>
									<input type="text" className="form-control hour-input" name="start_folio" id="start_folio"
										value={this.state.start_folio} onChange={this.handleChange}/>
								</div>
								<div className="form-group">
									<span className="span-min">Folio Hasta</span>
									<input type="text" className="form-control hour-input" name="end_folio" id="end_folio"
										value={this.state.end_folio} onChange={this.handleChange}/>
								</div>
								<div className="form-group">
									<span className="span-min">Sección</span>
									<select className="form-control" name="option" id="option" 
										value={this.state.option} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="laboratory">Laboratorio</option>
										<option value="division">Fraccionamiento</option>
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Sesión</span>
									<select className="form-control" name="work_sessions_id" id="work_sessions_id" 
										value={this.state.work_sessions_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.work_sessions.map((w, i)=>{
											return <option key={i} value={w.type}>
												{w.value}
											</option>
										})}
									</select>
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",fontSize: "20px"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
									</div>
								</div>
								<div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generateExcel(e)} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.generatePDF(e)}>PDF</button>
                                </div>

								<div className="col-xs-12 form-group" id="table-list">
									<div className="table-responsive">
										<table style={{fontSize:"10px !important"}} className="table expenses-discards" id="table-to-list">
                                            <thead>
                                                <tr>
                                                    {this.state.columns.map((col, i)=>                                                            
                                                        <th key={i} rowSpan={col.rowSpan} colSpan={col.colSpan} style={{width:col.width}}>
                                                            {col.title}
                                                        </th>
                                                    )}
                                                </tr>
                                                <tr>
                                                    {this.state.columns.map((column)=>
                                                        column.cols !== undefined &&
                                                            column.cols.map((col, j)=>
                                                                <th key={j}>
                                                                    {col.title}
                                                                </th>
                                                            )
                                                        
                                                    )}
                                                </tr>
                                                
                                            </thead>
                                            <tbody>                                                
                                                {this.state.listado.map((listado, i)=>
                                                    <tr key={i}>
                                                        {listado.map((list, j)=>                                                            
                                                            <td key={j}>
                                                                {list}
                                                            </td>
                                                        )}
                                                    </tr>                                                    
                                                )}
                                            </tbody>
										</table>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
            </div>
        )
    }
}

export default translate('translations') (DiscardsPerTurn);